import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revolution-slider7',
  templateUrl: './revolution-slider7.component.html'
})
export class RevolutionSlider7Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
